module.exports = __webpack_public_path__ + "img/wz-5-5.49872989.png";